import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { GranulationTypeId } from 'webapp/enums/enums';
import { TableColumnType } from 'webapp/enums/enums';
import { TrackingEvent } from 'webapp/enums/tracking';

import BlockSettingsMetricSortDataSelectComponent from 'webapp/components/block/settings/metric/sort-data-select';
import FormGranulationDropdownComponent from 'webapp/components/form/granulation/dropdown';
import FormRadiobuttonGroupComponent from 'webapp/components/form/radiobutton-group';

import type Block from 'webapp/models-custom/block';
import type BlockSetup from 'webapp/models-custom/block-setup';
import type VisualizationTable from 'webapp/models-custom/visualization/table';

interface Args {
	blockM: Block;
}

export default class BlockSettingsTableColumnTypeComponent extends Component<Args> {
	columnTypeOptions = [
		{
			value: TableColumnType.AUTO,
			label: 'Auto',
		},
		{
			value: TableColumnType.SINGLE,
			label: 'Single',
		},
		{
			value: TableColumnType.METRICS,
			label: 'Metrics',
		},
		{
			value: TableColumnType.GRANULATIONS,
			label: 'Granulations',
		},
	];

	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup(): BlockSetup {
		return this.block.blockSetup;
	}

	get visualization() {
		return this.blockSetup.visualization as VisualizationTable;
	}

	get selectedColumnType(): TableColumnType {
		return this.visualization.tableColumnType;
	}

	get showGranulation(): boolean {
		return this.selectedColumnType === TableColumnType.GRANULATIONS;
	}

	get showSortDataSelect(): boolean {
		return this.visualization.showSortDataSelect;
	}

	@action
	changeSelectedColumnType(columnType: AnySimpleValue): void {
		this.visualization.changeSelectedColumnType(columnType as TableColumnType);
	}

	@action
	changeGranulation(granulationId: string | null): void {
		const blockSetup = this.blockSetup;
		blockSetup.changeGranulation(granulationId as GranulationTypeId);
		blockSetup.trackMetricDataEvent(TrackingEvent.GRANULATION_CHANGED);
	}
	<template>
		<div class="row">
			<label>Show columns</label>
			<FormRadiobuttonGroupComponent
				class="radiobutton-switcher"
				@name="sortField"
				@selected={{this.selectedColumnType}}
				@options={{this.columnTypeOptions}}
				@onChange={{this.changeSelectedColumnType}}
				@theme="dark-blue"
			/>
		</div>

		{{#if this.showGranulation}}
			<div class="row">
				<label>Granulation</label>
				<FormGranulationDropdownComponent
					@metricLimitations={{this.blockSetup.limitations}}
					@onChange={{this.changeGranulation}}
					@theme="dark"
				/>
			</div>
		{{else if this.showSortDataSelect}}
			<BlockSettingsMetricSortDataSelectComponent @blockM={{@blockM}} @theme="dark" />
		{{/if}}
	</template>
}
